import ConsentGDPR from './CookieConsents';

export default ConsentGDPR;
